import * as _ from "lodash";

import { popularPagesHideRequestMessage, popularPagesShowRequestMessage } from "../../../actions/popularPagesActions";
import {
    leadingFolderDataReady,
    leadingFolderFetchData,
} from "../../../pages/website-analysis/website-content/leading-folders/LeadingFoldersActions";
import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { LeadingFoldersDashboardTableWidgetFilters } from "../widget-filters/LeadingFoldersDashboardTableWidgetFilters";

import { TableWidget } from "./TableWidget";

export class LeadingFoldersTableWidget extends TableWidget {
    public static getWidgetDashboardType() {
        return "Table";
    }

    public static getWidgetMetadataType() {
        return "LeadingFoldersTable";
    }

    public static getWidgetResourceType() {
        return "Table";
    }

    public static getFiltersComponent() {
        return LeadingFoldersDashboardTableWidgetFilters;
    }

    constructor() {
        super();
    }

    public getSearchKey() {
        return "Folder";
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    public onWidgetMount() {
        if (!this.dashboardId) {
            this._events.on(
                "widgetGetDataFail",
                _.debounce((data) => {
                    this._reduxService.dispatch(
                        popularPagesShowRequestMessage(this.apiParams.keys, data.headers("error-code") === "5001"),
                    );
                }, 100),
            );
            this._events.on(
                "widgetGetDataSuccess",
                _.debounce(() => {
                    this._reduxService.dispatch(popularPagesHideRequestMessage(this.apiParams.keys));
                }, 100),
            );
            this._events.on(
                "widgetCleanup",
                _.debounce(() => {
                    this._reduxService.dispatch(popularPagesHideRequestMessage(this.apiParams.keys));
                }, 100),
            );
        }
    }

    public callbackOnGetData(response) {
        super.callbackOnGetData(response);
        //SIM-21587
        if (!this.dashboardId) {
            this._reduxService.dispatch(leadingFolderDataReady(response));
        }
    }

    public getData() {
        if (this.dashboardId) {
            this._params.FolderHierarchySupport = false;
        }
        return super.getData().then((result) => {
            //SIM-21587
            if (!this.dashboardId) {
                this._reduxService.dispatch(leadingFolderFetchData());
            }
            return result;
        });
    }
}
LeadingFoldersTableWidget.register();
